const CryptoJS = require("crypto-js");
const PBKDF2 = require("crypto-js/pbkdf2");

let utils = {
    passHash(password, extraSalt) {
        extraSalt = extraSalt || "lckbx packing special";
        return "" + PBKDF2(password, extraSalt , {iterations: 1000, keySize: 256 / 32});
    },

    randomSalt() {
        return "" + CryptoJS.lib.WordArray.random(128 / 8);
    },

    md5(string) {
        return CryptoJS.MD5(string);
    },

    encrypt(password, contents) {
        if (typeof contents != "string") {
            contents = JSON.stringify(contents);
        }
        let res = CryptoJS.AES.encrypt(contents, password).toString()
        return res;
    },

    decrypt(password, contents) {
        let res = CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(contents, password));
        return res;
    },

    randomPass() {
        /* generates a new random password. rules:
            - variable length: 15-25 (as that effectively ^!10 or something the permutations
            - uppercase, lowercase, numbers
            - just one special char, randomly inserted somewhere, and is not any of the weird ones
        */

        // we are picking a pretty limited set of special chars - ones that are easily accessible on any keyboard
        // because the password is random this doesn't do much in terms of security, even if you'd know that the
        // set is limited
        let specialChars = "~!@#$%&*-?";
        let normalChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

        let betterRand = (range) => window.crypto.getRandomValues(new Uint32Array(1)) % range;

        let pass = "";
        let passLength = 15 + betterRand(10);
        for (var i = 0; i < passLength; i++) {
            pass += normalChars[betterRand(normalChars.length)];
        }

        let specialPos = betterRand(pass.length)
        pass = pass.substr(0, specialPos) + specialChars[betterRand(specialChars.length)] + pass.substr(specialPos);
        return pass
    },
};

export default utils;

